import React from 'react';
import {Link, useParams} from 'react-router-dom';
import {FamilyDetails, isFamily, spectra} from "./spectra";
import {Spectrum, SpectrumProps} from "./Spectrum";

type SpectrumWithParamsProps = Omit<SpectrumProps, "harmonics" | "name" | "url">;

interface SpectrumParams {
    family: string,
    offset: string;
}
export function SpectrumWithParams(props: SpectrumWithParamsProps) {
    const {family, offset} = useParams<SpectrumParams>();
    if (isFamily(family)) {
        const familyData: FamilyDetails = spectra[family];
        const length = familyData.members.length;
        if (length === 1) {
            // one wave only
            if (offset === undefined || +offset === 1) {
                // @ts-ignore
                let notes = familyData.description;
                return (<>
                    <p>{notes}</p>
                    <Spectrum harmonics={familyData.members[0].harmonics} name={family} url={`/${family}`} {...props} />
                </>);
            } else {
                return <p>There is only one wave in this family</p>;
            }
        } else if (offset !== undefined) {
            // multiple-wave family, and a wave is specified
            let nOffset = Number(offset);
            if (length !== 0 && nOffset <= length && nOffset > 0) {
                const wave = familyData.members[nOffset - 1];
                return (<>
                    <p>{wave.description ?? ""}</p>
                    <Spectrum harmonics={wave.harmonics} name={`${family} ${nOffset}`} url={`/${family}/${nOffset}`} {...props} />
                    <Link to={`/${family}`} style={{padding: "20px"}}>See whole { family } family</Link>
                </>);
            } else {
                return <p>The wave number you supplied is not valid</p>;
            }
        } else {
            // selected a family only
            let notes = familyData.description;
            const charts = familyData.members.map((_, i: number) => {
                const name = `${family} ${i + 1}`;
                return <Spectrum
                    key={name}
                    harmonics={familyData.members[i].harmonics}
                    name={name}
                    url={`/${family}/${i + 1}`}
                    {...props}
                />;
            });
            return (<>
                <p>{ notes }</p>
                { charts }
            </>);
        }
    }
    return <p>The wave family you supplied is not valid</p>;
}